import {useEffect, useMemo, useRef, useState } from 'react';
import './ChimeMeeting.scss';
import { useGlobalState } from '../../MeetContext/MeetContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../redux/app/hooks';
import { FETCH_POLICY, FETCH_POLICY_NO_CACHE, PTA_ROLE, SCHOOL_ADMIN, STUDENT_ROLE, TEACHER_ROLE, VIDEO_TILE_TEXT_SHADOW } from '../../utils/constants';
import images from '../../assets/images';
import { useLazyQuery, useMutation } from '@apollo/client';
import moment from 'moment';
import WarningPopup from '../WarningPopup/WarningPopup';
import { ContentShare, LocalVideo, RosterAttendeeType, useActiveSpeakersState, useAttendeeStatus, useContentShareControls, useContentShareState, useLocalVideo, useMeetingManager, useRosterState } from "amazon-chime-sdk-component-library-react";
import { useChimeMeeting } from '../../Chime/ChimeMeetingContext';
import RecordingTimer from '../Meeting/RecordingTimer/RecordingTimer';
import ChatBox from './MeetingChat/ChatBox/ChatBox';
import Dialogbox from '../Meeting/DialogBox/DialogBox';
import ScreenShareChoosePopup from '../Meeting/ScreenShare/ScreenShareChoosePopup';
import { Avatar } from '@mui/material';
import RemoteVideos from './RemoteVideos';
import ChimeMeetControls from './ChimeMeetControls/ChimeMeetControls';
import ChimeParticipantsListView from './ChimeParticipantsList/ChimeParticipantsListView';
import { ADD_USER_TO_VIDEO_CHAT_ROOM, CREATE_VIDEO_MEET_CHAT_ROOM, GET_UNREAD_MESSAGES_COUNT_FOR_VIDEO_MEET, GET_VIDEO_MEET_CHAT_ROOM } from '../../Chime/helpers/ChatApi/ChatQuery';
import ToasterWithMessage from '../toaster';
import ChimeMeetGroup from './ChimeMeetGroup/ChimeMeetGroup';
import { getInitials } from '../../utils/chimeHelper';
import { InitialiseChatConnection } from '../../websocket/ChatWebSocket';
import { getChimeParticipants } from '../../Chime/helpers/get-participants';
import ParticipantsListMobileView from '../../components/Meeting/ParticipantsList/ParticipantsListMobileView';
import { getScreenDimensions } from '../../utils/helper';
import MobileChat from '../Meeting/MeetingChat/MobileChat';
import { DefaultActiveSpeakerPolicy } from 'amazon-chime-sdk-js';
import { GET_WORKSHOP_BY_ID } from '../../pages/Workshop/api/WorkshopQuery';
import { useDispatch } from 'react-redux';
import { setCurrentPtaMeetId, setCurrentSessionDetail, setCurrentSessionId, setCurrentSessionRecordingDetail, setCurrentWorkshopId } from '../../redux/slices/dashboardSlice';
import { GET_SESSTION_BY_ID } from '../../pages/LiveClass/api/LiveClassQuery';
import { GET_PTA_MEETING_BY_ID } from '../../pages/AdminPta/api/PtaQuery';
import { ChatMessage } from '../Meeting/MeetingChat/types/MeetingChat.types';
import { useChimeMeetingChat } from '../../hooks/useChimeMeetingChat';

interface ChatMessages {
    id: any;
    message: string;
    userName: string;
    isReadBy: [
        {
            "userName": string,
            "userId": string,
            "attenteeId":string
        }
    ],
  }

  function useDebounceValue<T>(value: T, delay: number): T {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);

    return debouncedValue;
    }

    export function useDebouncedActiveSpeakers(delay: number = 500) {
        const activeSpeakers = useActiveSpeakersState();
        const debouncedSpeakers = useDebounceValue(activeSpeakers, delay);

        return debouncedSpeakers;
    }

const ChimeMeeting = () => {
    const { isChatOpen, isParticipantListView, isParticipantsGridViewVisible, toggleChat, toggleParticipant, handleParticipantsGridViewToggle} = useGlobalState();
    const { participantsRef, attendeesDataRef, attendeesData, setAttendeesData, subscribeToHandRaise, isHandRaised, isHost, hostId, attendeeId, isRecording, isRemoteSharing, endMeeting, leaveMeeting,setReadCount, isShowParticipants, showChat, setShowChat, userId:currentUserId,  setMediaPipelineArn, setMediaPipelineId, setRecordingStartTime, setIsRecording } = useChimeMeeting();
    const { role, loginpage, defaultVideoMute, defaultAudioMute, selectedClassRoomId } = useAppSelector((state) => state.auth);
    const timeUntilToastRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const timeUntilFinalCallRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const meetComponent = useAppSelector((state) => state?.dashboard?.meetComponent);
    const currentSessionDetail = useAppSelector((state) => state?.dashboard?.currentSessionDetail);
    const { currentSessionId, currentPtaMeetId } = useAppSelector((state) => state?.dashboard);
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const [openWarningPopup, setOpenWarningPopup] = useState<boolean>(false);
    const location = useLocation();
    const profile = useAppSelector((state) => state?.auth?.adminProfile);
    const { sharingAttendeeId } = useContentShareState();
    const { toggleContentShare } = useContentShareControls();
    const userName = profile?.getCurrentUser?.nodes[0]?.uFullName;
    const userId = profile?.getCurrentUser?.nodes?.[0]?.uUserName;
    const navigate = useNavigate();
    const {state} = useLocation();    
    const meetingManager = useMeetingManager();
    const {Microphone, MicrophoneOff, ParticipantRaiseHand} = images;
    const {
        muted,
        videoEnabled,
        sharingContent,
    } = useAttendeeStatus(attendeeId ? attendeeId : "");
    const { isVideoEnabled, setIsVideoEnabled } = useLocalVideo();
    const [ localAttendee, setLocalAttendee ] = useState<RosterAttendeeType & { color: string }>({chimeAttendeeId:'',externalUserId:'',name:'', color:''});
    const [chatRoomId, setChatRoomId] = useState('');
    const { roster } = useRosterState();
    const [initialRender, setInitialRender] = useState<boolean>(true);
    const [isReadCount, setIsReadCount] = useState<Boolean>(true);
    const activeSpeakers = useDebouncedActiveSpeakers();
    const [host, setHost] = useState<any>();
    const { error, warning } = ToasterWithMessage();
    const [chatMessages, setChatMessages] = useState<ChatMessage[]>([]);
    console.log(currentUserId, hostId, "currentUserId")
    const workshopID = localStorage.getItem('workshopId');
    const dispatch = useDispatch();

    const { sendMessage } = useChimeMeetingChat(setChatMessages);

    const handleSendMessage = (textMessage: string) => {
        sendMessage(textMessage);
    };

    useEffect(() => {
        if (!meetingManager?.meetingId) {
            handleNavigate();
        }
    }, []);

    const toggleCamera = async () => {
        if (isVideoEnabled || !meetingManager.selectedVideoInputDevice) {
            meetingManager.meetingSession?.audioVideo?.stopLocalVideoTile();
            // Change the state to hide the `LocalVideo` tile
            setIsVideoEnabled(false);
        } else {
            await meetingManager.meetingSession?.audioVideo?.startVideoInput(meetingManager.selectedVideoInputDevice);
            meetingManager.meetingSession?.audioVideo?.startLocalVideoTile();
            // Change the state to display the `LocalVideo` tile
            setIsVideoEnabled(true);
        }
    };

    const updateAudioVideoOnDeviceChange = async () => {
        const meetingAudioVideo = meetingManager?.meetingSession?.audioVideo;
        meetingAudioVideo?.addDeviceChangeObserver({
            async audioInputsChanged() {
                const audioInputDevices = await meetingAudioVideo?.listAudioInputDevices();
                const deviceId = audioInputDevices?.[0]?.deviceId;
                if (deviceId) meetingManager?.startAudioInputDevice?.(deviceId);
            },
            async audioOutputsChanged() {
                const audioOutputDevices = await meetingAudioVideo?.listAudioOutputDevices();
                const deviceId = audioOutputDevices?.[0]?.deviceId;
                if (deviceId) meetingManager?.startAudioOutputDevice?.(deviceId);
            },
            async videoInputsChanged() {
                const videoInputDevices = await meetingAudioVideo?.listVideoInputDevices();
                const deviceId = videoInputDevices?.[0]?.deviceId;
                if (deviceId) meetingManager?.startVideoInputDevice?.(deviceId);
            },
        });
    };

    useEffect( () => {
        subscribeToHandRaise();
        console.log("[Log] default audio and video", { defaultAudioMute, defaultVideoMute });
        if(meetingManager?.meetingId && !videoEnabled && !defaultVideoMute) {
            toggleCamera();
            console.log("[Log] defaultVideoMute", defaultVideoMute);
        }
        updateAudioVideoOnDeviceChange();
    },[]);

    useEffect( () => {
        if(roster && attendeeId){
            const attendeeData = roster[attendeeId] as RosterAttendeeType & { color: string };
            if (attendeeData) {
            // Set local attendee data with a color property
                setLocalAttendee({
                    ...attendeeData,
                    color: attendeeData?.color || '#bdbdbd'
                });
            }
            const attendeeKeys = Object.keys(roster);
            const temp :any[] = [];
            const partTemp: any = {};

            const filteredAttendeeKeys: string[] = attendeeKeys.filter(
                (attendeeId) => !activeSpeakers.includes(attendeeId)
            );

            const finalActiveSpeakers: string[] = activeSpeakers.map(
                (attendeeId) => attendeeId?.split('#')?.[0]
            );

            const finalAttendeeKeys: string[] = Array.from(new Set([...finalActiveSpeakers, ...filteredAttendeeKeys]));
            console.log("[Activespeakers] ---------------");
            console.log("[Activespeakers] activeSpeakers", activeSpeakers);
            console.log("[Activespeakers] finalActiveSpeakers", finalActiveSpeakers);
            console.log("[Activespeakers] attendeeKeys", attendeeKeys);
            console.log("[Activespeakers] filteredAttendeeKeys", filteredAttendeeKeys);
            console.log("[Activespeakers] finalAttendeeKeys", finalAttendeeKeys);
            console.log("[Activespeakers] ---------------");
            console.log("[Activespeakers] ----------> ", { activeSpeakers, attendeeKeys, finalActiveSpeakers, filteredAttendeeKeys, finalAttendeeKeys });
            const results = finalAttendeeKeys.map( (id: any ) => {
                const chimeId = id?.split('#')?.[0];
                const attendeeData = roster?.[chimeId] as RosterAttendeeType & { color: string } || {};
                partTemp[chimeId] = {attendeeData, handRaised: participantsRef.current?.[chimeId]?.handRaised ?? false};
                console.log('attendee data inside the loop=====>',attendeeData);

                if(attendeeData?.chimeAttendeeId !== attendeeId && !attendeeData?.externalUserId?.includes("aws:MediaPipeline") && attendeeData?.externalUserId &&  attendeeData?.chimeAttendeeId && attendeeData?.name){
                    temp.push({
                        chimeAttendeeId : attendeeData?.chimeAttendeeId,
                        externalUserId: attendeeData?.externalUserId,
                        name: attendeeData?.name,
                        handRaised: participantsRef.current?.[attendeeData?.chimeAttendeeId]?.handRaised ?? false,
                        color: attendeeData?.color || '#bdbdbd'
                    });
                }
            });
            console.log("[Log] results", results);
            participantsRef.current = partTemp;
            setAttendeesData(temp);
            attendeesDataRef.current = temp;
        }

        const audioVideo = meetingManager?.meetingSession?.audioVideo;

        if (audioVideo) {
            const activeSpeakerCallback = (activeSpeakerss: string[]) => {
                console.log("[Log] activeSpeakerss detector", {activeSpeakerss, data: activeSpeakerss?.map((id, index) => ({no: index, name: roster?.[id?.split('#')?.[0]]?.name, id: id}))});
            }
    
            audioVideo.subscribeToActiveSpeakerDetector(new DefaultActiveSpeakerPolicy(), activeSpeakerCallback);

            return () => {
                audioVideo.unsubscribeFromActiveSpeakerDetector(activeSpeakerCallback);
            };
        }
    }, [roster, activeSpeakers]);

    const handleNavigate = () => {
        if (role === STUDENT_ROLE) {
            navigate('/student-classroom/liveclass', { state: state });
        } else if (role === TEACHER_ROLE && meetComponent === 'liveclass') {
            navigate('/teacher-classroom/liveclass', { state: state });
        } else if (role === TEACHER_ROLE && meetComponent === 'workshop') {
            navigate('/teacher-workshop');
        } else if (role === TEACHER_ROLE && meetComponent === 'pta') {
            navigate('/teacher-pta', { state: state });
        } else if (((role === SCHOOL_ADMIN && loginpage === SCHOOL_ADMIN)) && meetComponent === 'pta') {
            navigate('/admin-pta/meetings', { state: state });
        } else if (((role === SCHOOL_ADMIN && loginpage === SCHOOL_ADMIN)) && meetComponent === 'workshop') {
            navigate('/admin-workshop');
        } else if (role === PTA_ROLE) {
            navigate('/pta-meetings', { state: state });
        }
    }
    
    const checkEndTime = async() => {
        console.log('checkEndTime=====>',isHost);
        if((currentUserId === hostId)){
            try {
                await endMeeting();
            } catch (error) {
                console.error('Failed to end meeting:', error);
                alert('An error occurred while end the meeting. Please try again.');
            }
        }else{
            try {
                await leaveMeeting();
            } catch (error) {
                console.error('Failed to leave meeting:', error);
                alert('An error occurred while leaving the meeting. Please try again.');
            }
        }
        toggleChat(false);
        toggleParticipant(false);
        handleParticipantsGridViewToggle(false);
        handleNavigate();
    };
    
    const [getWorkshopDetail, { data: workshopData }] = useLazyQuery(GET_WORKSHOP_BY_ID, {
    fetchPolicy: "network-only",
    onError: (err) => {
        error(err?.message);
        console.log("workshop error", err);
    }
    });

    const [getSingleSessionDetail, { data: sessionDetailData }] = useLazyQuery(GET_SESSTION_BY_ID, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onError: (err) => {
            error(err?.message);
        }
    });

    const [getSinglePtaMeeting, { data: ptaMeetingData }] = useLazyQuery(GET_PTA_MEETING_BY_ID, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onError: (err) => {  
            error(err?.message);
        }
    });

    useEffect(() => {
        if (workshopID && (meetComponent === 'workshop')) {
            getWorkshopDetail({
                variables: {
                    input: {
                        wsId: workshopID
                    }
                }
            });
        }
        if (currentSessionId && selectedClassRoomId && selectedSubjectId && meetComponent === 'liveclass') {
            getSingleSessionDetail({
                variables: {
                    input:{
                        cId:selectedClassRoomId,
                        sjId:selectedSubjectId,
                        sId: currentSessionId
                    }
                }
            });
        }
        if (currentPtaMeetId && meetComponent === 'pta') {
            getSinglePtaMeeting({
                variables: {
                    mId: currentPtaMeetId
                }
            });
        }
    }, [workshopID, meetComponent, currentSessionId, currentPtaMeetId, selectedSubjectId, selectedClassRoomId]);

        const processSessionTimers = (startTime: string, endTime: string) => {
            console.log("processSessionTimers called with", startTime, endTime);
                const start = moment(startTime);
                const end = moment(endTime);

                const duration = moment.duration(end.diff(start)).asMinutes();

                let adjustedEndTime;
                if (duration <= 5) {
                    adjustedEndTime = end.clone().subtract(1, 'minute');
                } else {
                    adjustedEndTime = end.clone().subtract(5, 'minutes');
                }

                const currentTime = moment();
                const timeUntilToast = adjustedEndTime.diff(currentTime);
                const timeUntilFinalCall = end.clone().add(1, 'minute').diff(currentTime);

                if (timeUntilToast > 0) {
                    timeUntilToastRef.current = setTimeout(() => {
                        if((role === SCHOOL_ADMIN && meetComponent === 'workshop') || (role === TEACHER_ROLE && meetComponent === 'liveclass') || (role === SCHOOL_ADMIN && loginpage === SCHOOL_ADMIN && meetComponent === 'pta') ){
                                setOpenWarningPopup(true);
                        }
                    }, timeUntilToast);
                }

                if (timeUntilFinalCall > 0) {
                    timeUntilFinalCallRef.current = setTimeout(() => {
                        console.log("timeUntilFinalCall", timeUntilFinalCall);
                        checkEndTime();
                    }, timeUntilFinalCall);
                }
        };

        // Single useEffect to handle timers for all meeting types, gated by meetComponent
        useEffect(() => {
                let startTime: string | undefined;
                let endTime: string | undefined;

                if (meetComponent === 'workshop' && workshopData?.getWorkShopByWsId) {
                    console.log("inside useEffect after workshop API");
                    startTime = workshopData.getWorkShopByWsId.wsStartTime;
                    endTime = workshopData.getWorkShopByWsId.wsEndTime;
                } else if (meetComponent === 'liveclass' && sessionDetailData?.getSession) {
                    console.log("inside useEffect after liveclass session API");
                    startTime = sessionDetailData.getSession.startdate;
                    endTime = sessionDetailData.getSession.enddate;
                } else if (meetComponent === 'pta' && ptaMeetingData?.getMeetingById) {
                    console.log("inside useEffect after pta meeting API");
                    startTime = ptaMeetingData.getMeetingById.mStartTime;
                    endTime = ptaMeetingData.getMeetingById.mEndTime;
                }

                console.log("startTime and endTime", startTime, endTime);
                if (startTime && endTime) {
                    processSessionTimers(startTime, endTime);
                }

                return () => {
                    if(timeUntilToastRef.current){
                        clearTimeout(timeUntilToastRef.current);
                    }
                    if(timeUntilFinalCallRef.current){
                        clearTimeout(timeUntilFinalCallRef.current);
                    }
                }
        }, [meetComponent, workshopData?.getWorkShopByWsId, sessionDetailData?.getSession, ptaMeetingData?.getMeetingById, checkEndTime]);

    useEffect(() => {
        if(meetComponent === 'workshop' && workshopData?.getWorkShopByWsId?.wsId) {
            setMediaPipelineArn(workshopData?.getWorkShopByWsId?.mediaPipelineArn);
            setMediaPipelineId(workshopData?.getWorkShopByWsId?.mediaPipelineId);
            dispatch(setCurrentWorkshopId({ currentWorkshopId: workshopData?.getWorkShopByWsId?.wsId }));
            dispatch(setCurrentSessionDetail({ 
                startDate: workshopData?.getWorkShopByWsId?.wsStartTime, 
                endDate: workshopData?.getWorkShopByWsId?.wsEndTime , 
                mediaPipelineArn : workshopData?.getWorkShopByWsId?.mediaPipelineArn ?? null , 
                mediaPipelineId : workshopData?.getWorkShopByWsId?.mediaPipelineId ?? null 
            }));
            dispatch(setCurrentSessionRecordingDetail({ 
                recordingStartedTime: workshopData?.getWorkShopByWsId?.recordStartTime, 
                recordingStarted: workshopData?.getWorkShopByWsId?.isRecordStart 
            }));
            setRecordingStartTime(workshopData?.getWorkShopByWsId?.recordStartTime);
            setIsRecording(workshopData?.getWorkShopByWsId?.isRecordStart);
        } else if (meetComponent === 'liveclass' && sessionDetailData?.getSession) {
            const session = sessionDetailData?.getSession;
            dispatch(setCurrentSessionId({ currentSessionId: session?.sessionId }));
            dispatch(setCurrentSessionDetail({
                startDate: session?.startdate,
                endDate: session?.enddate,
                mediaPipelineArn: session?.mediaPipelineArn ?? null,
                mediaPipelineId: session?.mediaPipelineId ?? null,
            }));
            dispatch(setCurrentSessionRecordingDetail({
                recordingStartedTime: session?.recordStartTime,
                recordingStarted: session?.isRecordStart ?? false,
            }));
            setRecordingStartTime(session?.recordStartTime);
            setIsRecording(session?.isRecordStart ?? false);
            setMediaPipelineArn(session?.mediaPipelineArn ?? null);
            setMediaPipelineId(session?.mediaPipelineId ?? null);
        } else if (meetComponent === 'pta' && ptaMeetingData?.getMeetingById) {
            const pta = ptaMeetingData?.getMeetingById;
            dispatch(setCurrentPtaMeetId({ currentPtaMeetId: pta?.mId }));
            dispatch(setCurrentSessionDetail({
                startDate: pta?.mStartTime,
                endDate: pta?.mEndTime,
                mediaPipelineArn: pta?.mediaPipelineArn ?? null,
                mediaPipelineId: pta?.mediaPipelineId ?? null,
            }));
            dispatch(setCurrentSessionRecordingDetail({
                recordingStartedTime: pta?.recordStartTime,
                recordingStarted: pta?.isRecordStart ?? false,
            }));
            setRecordingStartTime(pta?.recordStartTime);
            setIsRecording(pta?.isRecordStart ?? false);
            setMediaPipelineArn(pta?.mediaPipelineArn ?? null);
            setMediaPipelineId(pta?.mediaPipelineId ?? null);
        }
    }, [meetComponent, workshopData, sessionDetailData, ptaMeetingData]);

      const closeWarnPopup  = () => {
        setOpenWarningPopup(false);
      }

    useEffect(() => {
        console.log("meeting status changed", meetingManager?.meetingStatus);
        if(meetingManager?.meetingStatus === 3 || meetingManager?.meetingStatus === 4 || meetingManager?.meetingStatus === 5){
            // if (meetingManager?.meetingStatus === 3) {
            //     warning("Meeting has ended");
            // }
            if (meetingManager?.meetingStatus === 4) {
                warning("You have joined from another device.");
            }
            setTimeout(() => {
            if(role && meetComponent){
                toggleChat(false);
                toggleParticipant(false);
                handleParticipantsGridViewToggle(false);
                if(role === STUDENT_ROLE){
                    navigate('/student-classroom/liveclass',{state:state});
                }else if(role === TEACHER_ROLE && meetComponent === 'liveclass'){
                    navigate('/teacher-classroom/liveclass',{state:state});
                }else if(role === TEACHER_ROLE && meetComponent === 'workshop'){
                    navigate('/teacher-workshop');
                }else if(role === TEACHER_ROLE && meetComponent === 'pta'){
                    navigate('/teacher-pta', {
                        state: location?.state
                      });
                }else if(((role === SCHOOL_ADMIN && loginpage === SCHOOL_ADMIN)) && meetComponent === 'pta'){
                    navigate('/admin-pta/meetings', {
                        state: location?.state
                      });
                }else if(((role === SCHOOL_ADMIN && loginpage === SCHOOL_ADMIN)) && meetComponent === 'workshop'){
                    navigate('/admin-workshop');
                }else if(role === PTA_ROLE) {
                    navigate('/pta-meetings', {
                        state: {
                            category: location?.state?.category
                        }
                      });
                }
           }
            }, 2000)
        }
    }, [meetingManager?.meetingStatus])

    useEffect(()=>{
       console.log("isRecording=======>",isRecording)
    },[isRecording]);

    useEffect(() => {
        console.log("[Log Host] debug hostid", hostId, attendeesData, userId);
        if(hostId) {
        setHost(attendeesData.find((participant: any) => participant?.externalUserId === hostId));
        }
    }, [attendeesData, hostId, currentUserId]);

    useEffect(()=>{
        console.log("[Log Host] debug host", host, attendeesData, userId, hostId);
    },[host,attendeesData, userId, hostId]);


    const handleStopShareScreen = () => {
        if (sharingContent) {
            toggleContentShare();
        }
    }

    console.log("participants", videoEnabled, isVideoEnabled);
    console.log('attendees data',attendeesData,'roaster--------->',roster);
    console.log('meetingmanager', meetingManager);
    console.log('meetingmanager meetingStatus', meetingManager?.meetingStatus);
    console.log("handraise", isHandRaised);
    console.log("isRemotesharing======>",isRemoteSharing);
    console.log("sharingAttendeeId=====>",sharingAttendeeId, sharingAttendeeId ? roster[sharingAttendeeId.split('#')?.[0]]?.name : "");
    console.log("localAttendee====>",localAttendee);
    console.log("host", host);

    const memoizedAttendees = useMemo(() => attendeesData, [attendeesData]);

    useEffect(() => {
        console.log("[Log] memoizedAttendees", memoizedAttendees);
    }, [memoizedAttendees])

    useEffect(() => {
        const handler = () => {
            localStorage.setItem("wayOfLeft", "invalid");
            localStorage.setItem("isJoined", "left");
        };
    
        window.addEventListener("beforeunload", handler);
        window.addEventListener("popstate", handler);
    
        return () => {
            window.removeEventListener("beforeunload", handler);
            window.removeEventListener("popstate", handler);
        };
    }, []);

    return(
        <>
        {isParticipantsGridViewVisible ? (
            <ChimeMeetGroup localAttendee={localAttendee}/>
        ) : (
        <>
        <div className='videoMainContainerChime' style={{flexDirection: (sharingContent || sharingAttendeeId) ? 'column-reverse' : 'column'}}>
            {(attendeesData.length > 0 || (attendeesData?.length === 0 && sharingContent) || (!(currentUserId === hostId) && host)) &&
                <div className='OthersVideoContainer' style={{padding: (sharingContent || sharingAttendeeId) ? '5px 10px 10px 10px' : '', display:getScreenDimensions().isMobileScreen?"none":"flex", }}>
                    {(sharingContent || sharingAttendeeId || (!(currentUserId === hostId) && host)) && (
                        <div className="remote-tile-innerContainer">
                            <div className="remote-tile-icon">
                                <div className="micIconContainer">
                                    {!getScreenDimensions()?.isMobileScreen && <img src={ (muted) ? MicrophoneOff : Microphone } className={"micIcon"} alt="videoOn" />}
                                </div>
                                <div className="handIconContainer">
                                    <img src={ParticipantRaiseHand} className={isHandRaised ? 'raiseHandStyle' : 'raiseHandHidden'} alt="videoOn"/>
                                </div>
                            </div>
                                {videoEnabled ? (
                                    <>
                                        <LocalVideo className='local-video-tile'  />
                                        <div className="participantName">
                                            <span style={{ textShadow: VIDEO_TILE_TEXT_SHADOW, letterSpacing: "1px" }}>
                                                {localAttendee?.name ?
                                                    `${(localAttendee?.name)?.charAt(0).toUpperCase() + (localAttendee?.name)?.slice(1)} ${localAttendee.externalUserId === hostId ? `(Host)` : ''}`
                                                    : ""}
                                            </span>
                                        </div>
                                    </>) : (
                                    <div style={{display:'flex', justifyContent:'center', alignItems:'center', backgroundColor: 'black'}} className="remote-video">
                                        <Avatar sx={{ width: 80, height: 80, fontSize: 24, fontWeight:600, zIndex: 1 , backgroundColor:localAttendee?.color}}>{getInitials(localAttendee?.name)}</Avatar>
                                        <div className="participantName">
                                            <span style={{ textShadow: VIDEO_TILE_TEXT_SHADOW, letterSpacing: "1px" }}>
                                                {localAttendee?.name ?
                                                    `${(localAttendee?.name)?.charAt(0).toUpperCase() + (localAttendee?.name)?.slice(1)} ${localAttendee.externalUserId === hostId ? `(Host)` : ''}`
                                                    : ""}
                                            </span>
                                        </div>
                                    </div>
                                )}
                        </div>
                    )}
                    {((!(currentUserId === hostId) && host) && (sharingAttendeeId || sharingContent)) && (
                        <RemoteVideos Attendee={host} key={host?.chimeAttendeeId} hand={host.handRaised} isMainTile={false} hostId={hostId!}/>
                    )}
                    {memoizedAttendees.map( (attendee: any, index) =>  {
                        if (attendee?.externalUserId !== hostId) {
                            return <RemoteVideos Attendee={attendee} key={attendee.externalUserId ?? attendee.chimeAttendeeId} hand={attendee.handRaised} isMainTile={false} hostId={hostId!}/>
                        }
                    })}
                </div> 
            }
             {(attendeesData.length > 0 || (attendeesData?.length === 0 && sharingContent) || ((currentUserId === hostId))) &&getScreenDimensions().isMobileScreen&&
                <div className='OthersVideoContainer' style={{padding: (sharingContent || sharingAttendeeId) ? '5px 10px 10px 10px' : '', position:"absolute", zIndex: getScreenDimensions().isMobileScreen ? 999 : 999999999, top:10,}}>
                    {(sharingContent || sharingAttendeeId || (!(currentUserId === hostId) && host)) && videoEnabled &&  (
                        <div className="remote-tile-innerContainer">
                            <div className="remote-tile-icon">
                                <div className="micIconContainer">
                                    {getScreenDimensions()?.isMobileScreen && <img src={ (muted) ? MicrophoneOff : Microphone } className={"micIcon"} alt="videoOn" />}
                                </div>
                                <div className="handIconContainer">
                                    <img src={ParticipantRaiseHand} className={isHandRaised ? 'raiseHandStyle' : 'raiseHandHidden'} alt="videoOn"/>
                                </div>
                            </div>
                                {videoEnabled ? (
                                    <>
                                        <LocalVideo className='local-video-tile'  />
                                        <div className="participantName">
                                            <span style={{ textShadow: "0 1px 2px rgba(0,0,0,.6),0 0 2px rgba(0,0,0,.3)", letterSpacing: "1px" }}>
                                                {localAttendee?.name ?
                                                    `${(localAttendee?.name)?.charAt(0).toUpperCase() + (localAttendee?.name)?.slice(1)} ${localAttendee.externalUserId === hostId ? `(Host)` : ''}`
                                                    : ""}
                                            </span>
                                        </div>
                                    </>) : (
                                   null
                                )}
                        </div>
                    )}
                    {/* {!isHost && memoizedAttendees.map( (attendee: any, index) =>  {
                        if (attendee?.externalUserId !== hostId) {
                            return <RemoteVideos Attendee={attendee} key={attendee.externalUserId ?? attendee.chimeAttendeeId} hand={attendee.handRaised} isMainTile={false} hostId={hostId!}/>
                        }
                    })} */}
                </div> 
            }
            {
                   getScreenDimensions()?.isMobileScreen  && showChat &&
                      <MobileChat propChatRoomId={chatRoomId} />
            }
         
            <div className='localVideoContainer'>
                <div className='localVideoTile'>
                {(isRecording) && <RecordingTimer initialRender={initialRender} setInitialRender={setInitialRender}/>}
                {(sharingAttendeeId && !sharingContent) ? (
                    <div className="share-container">
                        <ContentShare nameplate={`${roster[sharingAttendeeId.split('#')?.[0]]?.name} is presenting`} className='local-share'/>
                    </div>
                ) : (
                    sharingContent ? (
                        <>
                            <div className='stopScreenShareContainer'>
                                <div className='sharedPersonName'>{"You are presenting"}</div>
                                <div className='stopShareElement' onClick={handleStopShareScreen}>
                                    <div className='stopIconStyle'></div>
                                    <div className='stopTextStyle'>{`Stop`}</div>
                                </div>
                            </div>
                            <ContentShare nameplate='You are presenting' className='local-share'/>
                        </>
                    ) : ((!(currentUserId === hostId) && host) ? (
                        <RemoteVideos Attendee={host} key={host?.chimeAttendeeId} hand={host.handRaised} isMainTile={true} hostId={hostId!}/>
                    ) : (
                        <div className='localTileContainer'>
                            <div className='iconsContainer'>
                                <div className="micIconContainer">
                                   {!getScreenDimensions()?.isMobileScreen && <img src={ (muted) ? MicrophoneOff : Microphone } className={"micIcon"} alt="videoOn" />}

                                </div>
                                <div className="handIconContainer">
                                    <img src={ParticipantRaiseHand} className={isHandRaised ? 'raiseHandStyle' : 'raiseHandHidden'} alt="videoOn"/>
                                </div>
                            </div>
                            {
                            videoEnabled ? (
                                <div className='local-tile'>
                                    <LocalVideo className='local-video-tile' />
                                    <div className="participantName">
                                        <span style={{ textShadow: VIDEO_TILE_TEXT_SHADOW, letterSpacing: "1px" }}>
                                            {localAttendee?.name ?
                                                `${(localAttendee?.name)?.charAt(0).toUpperCase() + (localAttendee?.name)?.slice(1)} ${localAttendee.externalUserId === hostId ? `(Host)` : ''}`
                                                : ""}
                                        </span>
                                    </div>
                                </div>) :
                                <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: getScreenDimensions()?.isMobileScreen ? 0 :"20px", backgroundColor: 'black' }}>

                                    <Avatar sx={{ fontSize: '100px', height: '200px', width: '200px', backgroundColor: localAttendee?.color }} >{getInitials(localAttendee?.name)}</Avatar>
                                    <div className="participantName">
                                        <span style={{ textShadow: VIDEO_TILE_TEXT_SHADOW, letterSpacing: "1px" }}>
                                            {localAttendee?.name ?
                                                `${(localAttendee?.name)?.charAt(0).toUpperCase() + (localAttendee?.name)?.slice(1)} ${localAttendee.externalUserId === hostId ? `(Host)` : ''}`
                                                : ""}
                                        </span>
                                    </div>
                                </div>
                            }
                        </div>
                    )
                )
                )
                }
                {
                    !(sharingContent || sharingAttendeeId) && 
                    <div className='meetControls'>
                        <ChimeMeetControls/>
                    </div>
                }
                </div>
                {(isChatOpen && showChat) && (
                    <div className='chatContainer'>
                        <ChatBox handleSendMessage = {handleSendMessage} chatMessages = {chatMessages} currentUserName={localAttendee?.name}/>
                    </div>
                )}
                {(isParticipantListView) && (
                    <div className='chatContainer'>
                        <ChimeParticipantsListView />
                    </div>
                )}
            </div>
            {
                (sharingContent || sharingAttendeeId) && 
                <div className='meetControlsOutside'>
                    <ChimeMeetControls/>
                </div>
            }
        </div>
        </>
        )}
        <Dialogbox />
        <WarningPopup
            message='The meeting will be automatically ended on scheduled time'
            openWarningPopup={ openWarningPopup }
            closeWarnPopup={ closeWarnPopup }
        />
        <ScreenShareChoosePopup />
        {
              getScreenDimensions()?.isMobileScreen  && isShowParticipants && 
              <div style={{height:80, width:'100%', position:"absolute"}}>
              <ParticipantsListMobileView/>
         </div>
        }
     
        </>
    )
}


export default ChimeMeeting;